export function ChevronLeft(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="9"
        height="18"
        viewBox="0 0 9 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.38387 1.08889C7.91423 0.686341 7.223 0.710267 6.78225 1.12436L6.69182 1.21905L1.24964 7.56826C0.582688 8.34637 0.545636 9.47399 1.13848 10.2909L1.24964 10.4317L6.69182 16.781C7.12312 17.2841 7.88068 17.3424 8.38387 16.9111C8.85352 16.5086 8.93559 15.8218 8.59378 15.3229L8.51403 15.2191L3.18392 9L8.51403 2.78095C8.91658 2.31131 8.89266 1.62008 8.47857 1.17933L8.38387 1.08889Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
